import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLABonnetedBatLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://utility.arcgis.com/usrsvcs/servers/e53ddb3e5376411caa292f4e5f7559c0/rest/services/BATS_SKINKS_V2/FeatureServer/0',
        visible: false,
        title: 'Bonneted Bat Consultation Area',
        popupTemplate: {
            outFields: ['*'],
            title: 'Bonneted Bat Consultation Area',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <p>
                            The regulatory requirements and mitigation procedures for this species of bat is fairly new. There have not been enough successful cases in review to
                            have a mitigation plan set in stone like many other endangered species. Enforcement has been implemented for small parcels such as a single family lot
                            as well as parcels going through subdividing process. The review is usually triggered by an application to the Army Corp of Engineers which then
                            notifies Fish and Wildlife Services. The site analysis requires expensive audio recordings over a period of time to see if the bat is present.
                        </p>
                        <p className="mt-3 mb-1">Hire a qualified environmental consultant before purchasing property if this layer is showing.</p>
                        <BSLAExternalLinkComponent href="http://myfwc.com/wildlifehabitats/imperiled/profiles/mammals/florida-bonneted-bat" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLABonnetedBatLayer;
